import { useTranslation } from "react-i18next";
import { FC, Props } from "./typings";
import styles from "./styles.module.scss";

import CloseIcon from "assets/icons/close.svg?react";
import threadsService from "api/threadsService";
import { useParams } from "react-router-dom";
import { useState } from "react";
import Input from "components/Input";
import Button from "components/Button";

const CaseThreadsModal: FC<Props> = ({ toggle }) => {
  const { t } = useTranslation();
  const [name, setName] = useState("");
  const { caseId } = useParams();

  const { mutate: createThread } = threadsService.useCreateThread();

  const { refetch } = threadsService.useGet(caseId!);

  const handleClickCreate = () => {
    createThread(
      {
        CaseId: caseId!,
        Items: [],
        Label: name,
      },
      {
        onSuccess: () => {
          toggle(false);
          refetch();
        },
      }
    );
  };

  return (
    <div className={styles.card}>
      <div className={styles.wrapper}>
        <div className={styles.header}>
          {t("modals.thread")}
          <CloseIcon
            className={styles.closeIcon}
            onClick={() => toggle(false)}
          />
        </div>
        <div className={styles.inputWrapper}>
          <Input
            placeholder={t("forms.threadName")}
            label=""
            value={name}
            onChange={(text) => setName(text)}
          />
        </div>
        <div className={styles.buttonWrapper}>
          <Button onClick={handleClickCreate} text={t("common.create")} />
        </div>
      </div>
    </div>
  );
};

export default CaseThreadsModal;
